import { supabase } from '../supabaseClient'

const PLATFORM_CONFIG_ID = '00000000-0000-0000-0000-000000000001'

export const getPlatformConfig = async () => {
  const { data, error } = await supabase
    .from('platform_config')
    .select('*')
    .eq('id', PLATFORM_CONFIG_ID)
    .single()

  return { data, error }
}

export const updatePlatformConfig = async (updates) => {
  const { data, error } = await supabase
    .from('platform_config')
    .update({
      ...updates,
      updated_at: new Date().toISOString()
    })
    .eq('id', PLATFORM_CONFIG_ID)
    .select()
    .single()

  return { data, error }
}

export const uploadPlatformAsset = async (file, assetType) => {
  const fileExt = file.name.split('.').pop()
  const filePath = `platform/${assetType}.${fileExt}`

  const { error: uploadError } = await supabase.storage
    .from('logos')
    .upload(filePath, file, { upsert: true })

  if (uploadError) return { url: null, error: uploadError }

  const { data: urlData } = supabase.storage
    .from('logos')
    .getPublicUrl(filePath)

  // Cache-busting: el path es fijo (platform/favicon.png), asi que al
  // reemplazar el archivo la URL no cambia y el CDN/navegador siguen
  // sirviendo el asset viejo. La version en el query fuerza la nueva.
  const url = urlData?.publicUrl ? `${urlData.publicUrl}?v=${Date.now()}` : null

  return { url, error: null }
}
